

define(['angular', 'squid/module', 'text!./template.html', 'xo-page-components/src/value-props/directive', 'xo-guest-components/src/guest/directive'], function (angular, module, template) {
  return angular.module('hermes.page.xo-guest.directive', ['squid', 'xo-value-props.directive', 'xo-onboard.payment.directive']).directive('xoGuest', function ($rootScope, $SingleStepModel) {
    return {
      template: template,
      scope: {
        token: '=?',
        parentCallbacks: '=?',
        isUnbranded: '=?',
        paymentMethod: '=?',
        buttonParams: '=?'
      },
      controller: function controller($scope, $rootScope, $state) {
        $scope.mode = 'guest';
        $rootScope.mode = 'guest';
        $scope.backUri = 'checkout.guest';
        $scope.singleStepModel = new $SingleStepModel();
        $scope.onComplete = function () {
          $state.go('checkout.end');
        };
      }
    };
  });
});


//////////////////
// WEBPACK FOOTER
// ./pages/xo-guest/directive.js
// module id = ./pages/xo-guest/directive.js
// module chunks = 0